import { createFileRoute } from "@tanstack/react-router"
import { userPreferencesViewStaticData } from "src/views/UserPreferencesView/constants"
import { UserPreferencesView } from "src/views/UserPreferencesView/UserPrefrencesView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/accounts/preferences")({
	component: UserPreferencesView,
	staticData: userPreferencesViewStaticData,
})
